export default () => ({
	mailBoxes: [],
});
